// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","584":"block","805":"transactions","809":"transfer"}[chunkId] + "." + {"11":"2763decb","95":"53af8df7","443":"2a53d963","571":"17672a76","584":"e5f2c787","805":"f5d66e22","809":"cbb5e365"}[chunkId] + ".js";
};